/**
 * Format any price value to a 2-decimal string (e.g., '99.00')
 * @param {number|string|null|undefined} value - Price value to format
 * @returns {string} Formatted price as 'XX.XX' string
 */
export const formatBasePrice = (value) => {
  if (value === null || value === undefined) {
    return '0.00';
  }

  // Handle string values that may include currency symbols
  let stringValue = String(value).trim();
  if (stringValue === '') {
    return '0.00';
  }

  // Remove currency symbols and whitespace
  stringValue = stringValue.replace(/[$\s]/g, '');

  // Parse to number
  const numericValue = parseFloat(stringValue);

  // Return "0.00" if parsing failed or result is NaN
  if (Number.isNaN(numericValue)) {
    return '0.00';
  }

  // Return formatted 2-decimal string
  return numericValue.toFixed(2);
};
